import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';
import React from 'react';
import Contract_Details from '../Contract_Details/Contract_Details';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const Contract = ({ details, noAction = false }) => {
  return (
    <React.Fragment>
      <FrameCard
        cardProps={{
          p: '.3em',
          borderRadius: '20px',
        }}
        jsx={
          <Contract_Details
            details={details}
            noAction={noAction}
          />
        }
      />
    </React.Fragment>
  );
};

export default Contract;
